import CardContent, { CardContentProps } from "@mui/material/CardContent";

export type { CardContentProps };

export default CardContent;
